import { Outlet } from 'react-router-dom';
import { DashboardLayoutSidebar } from './DashboardLayoutSidebar';
import { SidebarInset, SidebarProvider } from '@design-system/Sidebar';
import { DashboardLayoutBottomNavBar } from './DashboardLayoutBottomNavBar';
import { useBootup } from '@hooks/useBootup';
import { ErrorLoadingPage } from '@screens/ErrorHandling/ErrorLoadingPage';
import { Loader } from '@design-system/Loader';
import { ChatWidget } from '@design-system/ChatWidget';
import { useIframeModeStore } from '@/hooks/useIframeModeStore';

export const DashboardLayout = () => {
  const { isIframeMode } = useIframeModeStore ();

  if (isIframeMode) {
    return <IframeDashboardLayout />;
  }

  return <FullDashboardLayout />;
};

const IframeDashboardLayout = () => {
  return (
    <div className="flex flex-1 flex-col bg-background-secondary min-h-screen">
      <Outlet />
    </div>
  );
};

const FullDashboardLayout = () => {
  const { isError, isLoading } = useBootup ();

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <ErrorLoadingPage errorType="logout" hideNavBar />;
  }

  return (
    <SidebarProvider>
      <DashboardLayoutSidebar />
      <SidebarInset className="bg-background-secondary">
        <div className="flex flex-1 flex-col max-md:mb-16">
          <Outlet />
          <DashboardLayoutBottomNavBar />
        </div>
      </SidebarInset>
      <ChatWidget
        apiKey="08bba966-6817-4f0b-ae0f-91f53f9a8272"
        workflowTag="Peacock"
      />
    </SidebarProvider>
  );
};
